import React, { useContext } from 'react';
import { AppContext, DispatchContext } from '../AppContext';
import { Box, Popover, MenuItem, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import LanguageIcon from '@material-ui/icons/Language';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as actions from "../actions/actions";
import Service from "../services/service";


export default function LanguageMenu() {

    const useStyles = makeStyles(theme => ({
        root: {
            color: "white"
        },
        menuButton: {
            marginLeft: -12,
            marginRight: 10,
            marginTop: 0,
            color: "white",
            "&:hover": {
                backgroundColor: "rgba(255,255,255,0.2)"
            }
        },
    }));
    const [langPopup, setLangPopup] = React.useState(null);

    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles();

    const openLanguageMenu = (event) => {
        setLangPopup(event.currentTarget);
    }
    const closeLanguageMenu = () => {
        setLangPopup(null);
    }
    const handleLanguageChange = (lang) => {
        Service.setLanguage(lang);
        dispatch(actions.setLanguage(lang));
        closeLanguageMenu();
    }


    return (
        <Typography variant="body2">
            <Button className={classes.menuButton} onClick={openLanguageMenu}>
                <LanguageIcon />
                <ExpandMoreIcon />
            </Button>

            <Popover
                anchorEl={langPopup}
                keepMounted
                open={!!langPopup}
                onClose={closeLanguageMenu}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}>
                <Box mt={1} />
                <MenuItem key="langMenu.en" onClick={() => handleLanguageChange("en")}>{s.languages.en}</MenuItem>
                <MenuItem key="langMenu.de" onClick={() => handleLanguageChange("de")}>{s.languages.de}</MenuItem>
                <Box mt={1} />
            </Popover>
        </Typography>
    );
}
